<div class="offroad-trail-list-container">
  <div class="directions" i18n>Choose your vehicle (optional)</div>

  <ul class="list-unstyled">
    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleAllOffroadTrails"
        aria-label="Toggle All Offroad Trails"
        [checked]="isAllTrailsShowing"
        (change)="toggleAllOffroadTrails()"
        i18n-aria-label
      />
      <div>
        <div class="label"><strong i18n>All Off-Road Trails</strong></div>
      </div>
    </li>

    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleOhmTrails"
        aria-label="Toggle Ohm Trails"
        [checked]="isShowingOhmTrails"
        [class]="{ 'custom-radio-disabled': isOhmDisabled }"
        (change)="setIsShowingOhm()"
        i18n-aria-label
      />
      <img alt="OHM Trails" [ngSrc]="ohmImg" [class]="{ 'gray-image': isGrayImageOhm }" i18n-alt />
      <div>
        <div>
          <strong i18n>Dirt Bike: </strong>
          <span i18n>Off-Highway Motorcycles (single track)</span>
        </div>
      </div>
    </li>

    <li class="hidden-label" [ngClass]="{ 'visible-label': isShowingOhmTrails }" i18n>
      Other trails shown if OHM use is allowed
    </li>

    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleAtvTrails"
        aria-label="Toggle ATV Trails"
        [checked]="isShowingAtvTrails"
        [class]="{ 'custom-radio-disabled': isAtvDisabled }"
        (change)="setIsShowingAtv()"
        i18n-aria-label
      />
      <img alt="ATV Trails" [ngSrc]="atvImg" [class]="{ 'gray-image': isGrayImageAtv }" i18n-alt />
      <div>
        <strong i18n>ATV: </strong>
        <span i18n>All-Terrain Vehicles 50 inches wide or less, straddled by the rider</span>
      </div>
    </li>

    <li class="hidden-label" [ngClass]="{ 'visible-label': isShowingAtvTrails }" i18n>
      Other trails shown if ATV use is allowed
    </li>

    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleRov50Trails"
        aria-label="Toggle Ohm Trails"
        [checked]="isShowingRov50Trails"
        [class]="{ 'custom-radio-disabled': isRov50Disabled }"
        (change)="setIsShowingRov50()"
        i18n-aria-label
      />
      <img
        alt="side by side vehicle 50 inches or less"
        [ngSrc]="rov50Img"
        [class]="{ 'gray-image': isGrayImageRov50 }"
        i18n-alt
      />
      <div>
        <strong i18n>SxS &lt; 50": </strong>
        <span i18n>Side by side recreational Off-Road Vehicles 50 inches wide or less</span>
      </div>
    </li>

    <li class="hidden-label" [ngClass]="{ 'visible-label': isShowingRov50Trails }" i18n>
      Other trails shown if ROV&lt;50 use is allowed
    </li>

    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleRovTrails"
        aria-label="Toggle ROV Trails"
        [checked]="isShowingRovTrails"
        [class]="{ 'custom-radio-disabled': isRovDisabled }"
        (change)="setIsShowingRov()"
        i18n-aria-label
      />
      <img alt="side by side vehicles" [ngSrc]="rovImg" [class]="{ 'gray-image': isGrayImageRov }" i18n-alt />
      <div>
        <strong i18n>SxS: </strong>
        <span i18n>Side by side recreational Off-Road Vehicle, excluding highway-licensed vehicles</span>
      </div>
    </li>

    <li class="hidden-label" [ngClass]="{ 'visible-label': isShowingRovTrails }" i18n>
      Other trails shown if ROV use is allowed
    </li>

    <li class="trail-type-layer">
      <mat-radio-button
        id="toggleOtherTrails"
        aria-label="Toggle Other Trails"
        [checked]="isShowingOtherTrails"
        [class]="{ 'custom-radio-disabled': isOtherDisabled }"
        (change)="setIsShowingOther()"
        i18n-aria-label
      />
      <img alt="Other Trails" [ngSrc]="otherImg" i18n-alt />
      <div>
        <strong i18n>HLV: </strong>
        <span i18n>Highway licensed vehicles</span>
      </div>
    </li>

    <li class="hidden-label" [ngClass]="{ 'visible-label': isShowingOtherTrails }" i18n>
      Other trails shown if other use is allowed
    </li>
  </ul>

  <div class="bottom-directions helper-secondary-text">
    <i i18n>Class definitions vary by jurisdiction. Always familiarize yourself with local rules and regulations.</i>
  </div>

  <div class="designated-list-title" i18n>Also show / snap to</div>

  <ul class="designated-list list-unstyled">
    <li class="trail-type-layer">
      <mat-checkbox
        id="toggleNonDesignated"
        aria-label="Toggle Designated Route Unpaved*"
        [checked]="isShowingDesignatedUnpavedTrails"
        (change)="setIsShowingDesignatedUnpaved($event.checked)"
        i18n-aria-label
      />
      @if (!isShowingSatellite) {
        <img
          alt="Designated Route Unpaved"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-unpaved.svg"
          i18n-alt
        />
      } @else {
        <img
          alt="Designated Route Unpaved"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-unpaved-sat.svg"
          i18n-alt
        />
      }
      <div i18n>Designated Route Unpaved</div>
    </li>
    <li class="trail-type-layer">
      <mat-checkbox
        id="toggleNonDesignatedPaved"
        aria-label="Toggle Designated Route Paved"
        [checked]="isShowingDesignatedPavedTrails"
        (change)="setIsShowingDesignatedPaved($event.checked)"
        i18n-aria-label
      />
      @if (!isShowingSatellite) {
        <img
          alt="Non-Designated Paved"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-paved.svg"
          i18n-alt
        />
      } @else {
        <img
          alt="Designated Route Paved*"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-paved-sat.svg"
          i18n-alt
        />
      }
      <div i18n>Designated Route Paved</div>
    </li>
    <li class="trail-type-layer">
      <mat-checkbox
        id="toggleUnmaintained"
        aria-label="Toggle Unmaintained"
        [checked]="isShowingUnmaintainedTrails"
        (change)="setIsShowingUnmaintained($event.checked)"
        i18n-aria-label
      />
      @if (!isShowingSatellite) {
        <img
          alt="Unmaintained"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-unmaintained.svg"
          i18n-alt
        />
      } @else {
        <img
          alt="Unmaintained"
          ngSrc="/assets/icons/map-legend-icons/orv/icon-offroadtrails-unmaintained-sat.svg"
          i18n-alt
        />
      }
      <div i18n>Unmaintained</div>
    </li>
    <li class="trail-type-layer">
      <mat-checkbox
        id="toggleClosed"
        aria-label="Toggle Closed Trails"
        [checked]="true"
        [disabled]="true"
        i18n-aria-label
      />
      <img alt="Closed Trails" ngSrc="/assets/icons/map-legend-icons/icon-closed-trail.svg" i18n-alt />
      <div i18n>Closed</div>
    </li>
  </ul>
  <div class="bottom-directions helper-secondary-text" i18n>
    *Not designated as part of a trail system, but legal to ride with any class off-road vehicle. Maintained as-needed.
  </div>

  <div class="trail-difficulty-title">
    <mat-checkbox
      id="toggleOffRoadDifficulty"
      aria-label="Toggle difficulty"
      [checked]="isShowingTrailDifficulty"
      (change)="setTrailDifficulty($event.checked)"
      i18n-aria-label
    />
    <div i18n>Trail Difficulty</div>
  </div>
  <ul class="list-unstyled trail-difficulty-list">
    <li class="trail-type-layer">
      <img alt="Easy" ngSrc="/assets/icons/trail-difficulty/off-road-easy.svg" i18n-alt />
      <span i18n>Easy</span>
    </li>
    <li class="trail-type-layer">
      <img alt="Moderate" ngSrc="/assets/icons/trail-difficulty/off-road-moderate.svg" i18n-alt />
      <span i18n>Moderate</span>
    </li>
    <li class="trail-type-layer">
      <img alt="Difficult" ngSrc="/assets/icons/trail-difficulty/off-road-difficult.svg" i18n-alt />
      <span i18n>Difficult</span>
    </li>
    <li class="trail-type-layer">
      <img class="extreme-icon" alt="Extreme" ngSrc="/assets/icons/trail-difficulty/off-road-extreme.svg" i18n-alt />
      <span i18n>Extreme</span>
    </li>
  </ul>
</div>
